import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { convertToDate } from '../../../../../../../utils/helpers.utils';
import { OrderRequestFiles } from "../../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../../request-on-behalf-details.component";
import Translation from "../../../../../../common/translation/translation.component";

export class WirelineTerminateCircuitDetails extends Component {
    constructor(props) {
        super(props);
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    render() {
        const { data, isWireline } = this.props;
        return (
            <div>               
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" /></h4>
                <div className="order-detail-location">
                    <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="order_number" /></td>
                                <td>{data.Order.OrderNumber}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="subscription_number" /></td>
                                <td>{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription.PlanDetails.PlanName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription.VendorName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.SimType.SimTypeName}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="terminate_circuit_request_details" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="cancellation_date" /></td>
                                <td>{convertToDate(data.Order.OrderDisconnectDate, 'DD MMM YYYY')}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                {/*<td><Translation translationKey="additional_information" /></td>*/}
                                {/*<td>{data.BusinessJustification.AdditionalInformation}</td>*/}
                            </tr>
                        </tbody>
                    </Table>
                    {isWireline &&
                        <OrderRequestFiles files={data.Order.OrderFileNames} />
                    }
                </div>
            </div>
        );
    }
}